import Vue from 'vue'

export const RUTA_PLAN_DIARIO = 'ActividadesDiarias'
export const BLOQUEO_PLAN_DIARIO_EVENT = 'rh-bloqueo-plan-diario'
export const PLAN_DIARIO_GUARDADO_EVENT = 'rh-plan-diario-guardado'
export const bloqueoPlanDiarioBus = new Vue()

/** true = no bloquea menú ni rutas (solo local / pruebas). */
const BLOQUEO_PLAN_DIARIO_DESACTIVADO = false

let estadoActual = {
  iderp: null,
  aplica: false,
  restringido: false,
  cargado: false,
}

export function getEstadoBloqueoPlanDiario() {
  return Object.assign({}, estadoActual)
}

export function setEstadoBloqueoPlanDiario(parcial) {
  const next = Object.assign({}, estadoActual, parcial || {}, { cargado: true })
  if (BLOQUEO_PLAN_DIARIO_DESACTIVADO) {
    next.aplica = false
    next.restringido = false
  }
  estadoActual = next
  bloqueoPlanDiarioBus.$emit(BLOQUEO_PLAN_DIARIO_EVENT, getEstadoBloqueoPlanDiario())
  return getEstadoBloqueoPlanDiario()
}

export function estaRestringidoPlanDiario(iderp) {
  if (BLOQUEO_PLAN_DIARIO_DESACTIVADO) return false
  if (!estadoActual.restringido) return false
  if (estadoActual.iderp == null) return false
  return Number(estadoActual.iderp) === Number(iderp)
}

export function menuSoloPlanDiario() {
  return [
    {
      title: 'Mi Plan Diario',
      action: 'mdi-calendar-check',
      active: true,
      items: [
        {
          title: 'Mi Plan Diario',
          path: RUTA_PLAN_DIARIO,
          active: 0,
        },
      ],
    },
  ]
}
